import { render } from "./FormularioEdicao.vue?vue&type=template&id=a98b17c0&ts=true"
import script from "./FormularioEdicao.vue?vue&type=script&lang=ts"
export * from "./FormularioEdicao.vue?vue&type=script&lang=ts"

import "./FormularioEdicao.vue?vue&type=style&index=0&id=a98b17c0&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__